import React from 'react';
import css from './TermsSection.module.css';

const TermsSection = () => {
  return (
    <div className={css.wrapper}>
      {[
        {
          title: 'Get paid monthly with Stripe or PayPal',
          description: (
            <>
              We use Stripe for secure, direct-to-bank payouts.
              <br />
              Prefer PayPal? That's ok too. You'll be prompted to connect your method in your
              dashboard.
            </>
          ),
          ctaText: 'Terms Of Service',
          ctaLink: '/terms-of-service',
        },
        {
          title: 'Your work, your rules',
          description:
            "You always retain ownership of your scans. You're simply licensing them to others under the terms you choose. From personal use to full commercial, you'll be able to choose what applies per scan,",
          ctaText: 'Licensing Guide',
          ctaLink: '/licensing-guide',
        },
      ].map((box) => (
        <div className={css.box}>
          <p className={css.boxTitle}>{box.title}</p>
          <p className={css.boxDescription}>{box.description}</p>
          <a className={css.cta} href={box.ctaLink}>
            <span>{box.ctaText}</span>
          </a>
        </div>
      ))}
    </div>
  );
};

export default TermsSection;
